import { SALES_ORDER_FORM_DEFAULT_VALUES } from '#/modules/crmMgmt/salesOrder/schemas/salesOrderSchema';
import {
  getSalesOrderLineGrossAmount,
  getSalesOrderLineNetAmount,
  getSalesOrderLineDiscountRate,
  getSalesOrderLineUnitPrice,
} from '#/modules/crmMgmt/salesOrder/helper/mapSalesOrderMeta';
import {
  getSalesOrderLineInvAllocations,
  getSalesOrderLineMtrs,
  getSalesOrderLineQty,
  getSalesOrderTaxMode,
} from '#/modules/crmMgmt/salesOrder/helper/salesOrderFieldAccessors';

function clonePlainList(list) {
  if (!Array.isArray(list)) {
    return [];
  }
  return list.map((item) => (
    item && typeof item === 'object' && !Array.isArray(item)
      ? { ...item }
      : item
  ));
}

function mapAllocationToForm(allocation) {
  return {
    id: allocation?.id ?? null,
    salesOrderLineMtrId: allocation?.salesOrderLineMtrId
      ?? allocation?.customerOrderMaterialSnapshotId
      ?? null,
    invStockId: allocation?.invStockId ?? allocation?.inventoryStockId ?? null,
    mtrId: allocation?.mtrId ?? null,
    qty: allocation?.qty ?? '',
    availableQty: allocation?.availableQty ?? null,
    stockNo: allocation?.stockNo ?? null,
    warehouse: allocation?.warehouse ?? null,
    warehouseName: allocation?.warehouse?.name ?? allocation?.warehouseName ?? null,
  };
}

function mapLineToForm(line) {
  return {
    id: line?.id ?? null,
    customerOrderLineId: line?.customerOrderLineId ?? null,
    productId: line?.productId ?? line?.product?.id ?? null,
    qty: getSalesOrderLineQty(line) ?? '',
    remark: line?.remark ?? '',
    product: line?.product ?? null,
    // business input／顯示 hydrate 自 line.amount；不回寫派生金額
    unitPrice: getSalesOrderLineUnitPrice(line) ?? '',
    discountRate: getSalesOrderLineDiscountRate(line) ?? '',
    totalAmount: getSalesOrderLineNetAmount(line) ?? '',
    mtrs: clonePlainList(getSalesOrderLineMtrs(line)),
    invAllocations: getSalesOrderLineInvAllocations(line).map(mapAllocationToForm),
    extraItems: clonePlainList(line?.extraItems),
  };
}

function mapManualLineToForm(line) {
  return {
    id: line?.id ?? null,
    customerOrderManualLineId: line?.customerOrderManualLineId ?? null,
    itemName: line?.itemName ?? '',
    qty: line?.qty ?? '',
    unitName: line?.unitName ?? '',
    unitPrice: getSalesOrderLineUnitPrice(line) ?? '',
    remark: line?.remark ?? '',
    grossAmount: getSalesOrderLineGrossAmount(line) ?? '',
    netAmount: getSalesOrderLineNetAmount(line) ?? '',
  };
}

/**
 * Detail → RHF。
 * 地址／聯絡：header 三 ID；缺則從 `customerSnapshot` 巢狀 hydrate（可 null）。
 */
export function mapSalesOrderDetailToForm(detail) {
  if (!detail) {
    return { ...SALES_ORDER_FORM_DEFAULT_VALUES };
  }

  const snapshot = detail.customerSnapshot;

  return {
    plannedShipDate: detail.plannedShipDate ?? '',
    billingAddressId: detail.billingAddressId
      ?? snapshot?.billingAddress?.id
      ?? '',
    shippingAddressId: detail.shippingAddressId
      ?? snapshot?.shippingAddress?.id
      ?? '',
    shippingContactId: detail.shippingContactId
      ?? snapshot?.shippingContact?.id
      ?? '',
    currencyId: detail.currencyId ?? '',
    taxMode: getSalesOrderTaxMode(detail) ?? '',
    taxRate: detail.taxRate ?? '',
    roundingAdjustment: detail.roundingAdjustment ?? '',
    issueReason: detail.issueReason ?? '',
    remark: detail.remark ?? '',
    lines: (detail.lines ?? []).map(mapLineToForm),
    manualLines: (detail.manualLines ?? []).map(mapManualLineToForm),
    customerId: detail.customerId ?? detail.customer?.id ?? '',
  };
}
